import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const LocationSelectMultiple = ({
  locations,
  handleBlur,
  values,
  setFieldValue,
}) => {
  return (
    <Autocomplete
      size="small"
      options={locations}
      multiple
      noOptionsText="No Locations Available"
      getOptionLabel={(option) => option.name}
      onChange={(_, newValue) => {
        setFieldValue("location", newValue || []);
      }}
      value={values.location}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onBlur={handleBlur}
      renderInput={(params) => <TextField {...params} variant="outlined" />}
    />
  );
};

export default LocationSelectMultiple;
